import React, { useEffect, useState } from "react";
import {
  Cell,
  Table,
  TableBody,
  TableHead,
  TableHeader,
  TableRow,
} from "@vds/tables";
import { Badge } from "@vds/badges";
import { getMake, getModel } from "../../utility/tableUtils";
import { formatETA } from "../../utility/Utils";
import { Icon } from "@vds/icons";
import moment from "moment";
import { Notification } from "@vds/notifications";
import { Tooltip } from "@mui/material";
import { ReactComponent as Info } from "../../../assets/info.svg";
import { Body } from "@vds/typography";
import { Toggle } from "@vds/toggles";
import { useSelector } from "react-redux";
import { COMPANION_DEVICE_TABLE_LABELS } from "../../constants/devices";

const CompanionDeviceDetailsTable = (props) => {
  const {
    companionDeviceData,
    setShowEditDevice,
    storedTagIds,
    updateChannelInfo,
    setIsLiveChannelEdit,
    setdeviceInfo,
    setDeviceTagsList,
    isCloudStorageDevice,
    updateEvidenceStateOfCCD,
  } = props;
  const sitesTagList = useSelector((state) => state.sitesReducer?.siteTagList);
  const sites = sitesTagList.sites;
  const [clourder, setClouder] = useState(
    companionDeviceData?.customdata?.cansendmedia ? "enable" : "disable"
  );

  const tooltipContent = (
    <div className="companion-cloud-storage-tooltip-content">
      <Body viewport="desktop" size="small" bold={true}>
        {COMPANION_DEVICE_TABLE_LABELS.CLOUD_STORAGE}
      </Body>
      <div className="companion-cloud-storage-tooltip-body">
        <Body viewport="desktop" size="small">
          {COMPANION_DEVICE_TABLE_LABELS.CLOUD_STORAGE_TOOLTIP_BODY}
        </Body>
      </div>
    </div>
  );

  useEffect(() => {
    setClouder(
      companionDeviceData?.customdata?.cansendmedia ? "enable" : "disable"
    );
  }, [props.companionDeviceData]);

  const onCloudStoragetoggle = (e) => {
    setClouder(e.target.value == "enable" ? "disable" : "enable");
    updateEvidenceStateOfCCD(e.target.value == "enable" ? "disable" : "enable");
  };

  const getSiteDetails = (siteids) => {
    const siteId = siteids[0];
    const site = sites?.find((site) => site?.id === siteId);
    return site ? site?.name : "Not Available";
  };

  return (
    <>
      <div className="companion-device-details-table-wrapper">
        <Table
          className="companion-device-details-table"
          striped={false}
          bottomLine="secondary"
          padding="standard"
        >
          <TableHead bottomLine="primary" className="companion-device-table-head">
            <TableHeader>{COMPANION_DEVICE_TABLE_LABELS.STATUS}</TableHeader>
            <TableHeader>{COMPANION_DEVICE_TABLE_LABELS.SOFTWARE}</TableHeader>
            <TableHeader>{COMPANION_DEVICE_TABLE_LABELS.SITE}</TableHeader>
            <TableHeader>
              <span className="companion-cloud-storage-header">
                {COMPANION_DEVICE_TABLE_LABELS.CLOUD_STORAGE}
                <Tooltip
                  placement="top"
                  arrow
                  title={tooltipContent}
                  slotProps={{
                    tooltip: {
                      sx: {
                        backgroundColor: "white",
                        border: "1px solid black",
                        "& .MuiTooltip-arrow": {
                          backgroundColor: "white",
                        },
                      },
                    },
                  }}
                >
                  <sup>
                    {" "}
                    <Info />{" "}
                  </sup>
                </Tooltip>
              </span>
            </TableHeader>
          </TableHead>
          <TableBody>
            <TableRow className="companion-device-status-row">
              <Cell>
                <span className="companion-device-status-wrapper">
                  {(() => {
                    const status =
                      companionDeviceData?.fields?.connectivityStatus?.toLowerCase();
                    if (status === "inprogress") {
                      return (
                        <div className="companion-device-updating-wrapper">
                          <Badge fillColor={"blue"}>{COMPANION_DEVICE_TABLE_LABELS.UPDATING}</Badge>
                          {companionDeviceData?.fields?.ETA && (
                            <div className="companion-device-eta-text">
                              {COMPANION_DEVICE_TABLE_LABELS.ETA_PREFIX}{formatETA(companionDeviceData?.fields?.ETA)}
                            </div>
                          )}
                        </div>
                      );
                    }
                    let color = "orange";
                    let label = COMPANION_DEVICE_TABLE_LABELS.OFFLINE;
                    if (status === "online") {
                      color = "green";
                      label = COMPANION_DEVICE_TABLE_LABELS.ONLINE;
                    }
                    return <Badge fillColor={color}>{label}</Badge>;
                  })()}
                </span>
              </Cell>
              <Cell>
                {companionDeviceData?.softwareversion
                  ? companionDeviceData?.softwareversion
                  : COMPANION_DEVICE_TABLE_LABELS.NA}
              </Cell>
              <Cell>
                {" "}
                {companionDeviceData?.siteids?.length >= 1
                  ? getSiteDetails(companionDeviceData?.siteids)
                  : COMPANION_DEVICE_TABLE_LABELS.NOT_AVAILABLE}
              </Cell>
              <Cell>
                {" "}
                <div className="companion-cloud-storage-toggle-wrapper">
                  {" "}
                  {/* {companionDeviceData?.customdata?.cansendmedia ? (
                    <> */}
                  {clourder == "enable" ? (
                    <div className="companion-cloud-storage-status-label"> {COMPANION_DEVICE_TABLE_LABELS.ENABLED} </div>
                  ) : (
                    <div className="companion-cloud-storage-status-label"> {COMPANION_DEVICE_TABLE_LABELS.DISABLED} </div>
                  )}
                  <Toggle
                    value={clourder}
                    on={clourder == "enable"}
                    data-testid="companionDeviceInfoTable_toggleButton"
                    onChange={onCloudStoragetoggle}
                  />
                  {/* </>
                  ) : (
                    <>
                      <div style={{ margin: "3px 12px 0 0" }}> Disabled </div>{" "}
                      <Toggle value={companionDeviceData?.customdata?.cansendmedia}
                      onChange={onCloudStoragetoggle()} />
                    </>
                  )} */}
                </div>
              </Cell>
            </TableRow>
          </TableBody>
        </Table>
      </div>
    </>
  );
};

export default CompanionDeviceDetailsTable;
